import { UserApiBase } from '@/libs/apis/user/base';

export class UserPaymentApi extends UserApiBase {
  update(data) {
    return super.put(`payment/`, data, 'Failed to update payment');
  }
}
